var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19783 7.88605V4.86055C7.19783 3.65035 7.19783 3.04525 7.41025 2.58278C7.59733 2.17542 7.89451 1.84585 8.26185 1.63839C8.67889 1.40283 9.22454 1.40283 10.3158 1.40283H15.7724C16.8637 1.40283 17.4093 1.40283 17.8264 1.63839C18.193 1.84558 18.4911 2.17616 18.678 2.58278C18.8904 3.04525 18.8904 3.65035 18.8904 4.86055V10.9116C18.8904 12.1218 18.8904 12.7269 18.678 13.1893C18.491 13.5959 18.1929 13.9264 17.8264 14.1337C17.4093 14.3693 16.8637 14.3693 15.7753 14.3693H13.0441M7.19783 7.88605H4.46957C3.37827 7.88605 2.83262 7.88605 2.41558 8.12161C2.04888 8.32874 1.75075 8.65934 1.56398 9.066C1.35156 9.52847 1.35156 10.1336 1.35156 11.3438V17.3948C1.35156 18.605 1.35156 19.2101 1.56398 19.6726C1.75081 20.0792 2.04892 20.4098 2.41558 20.6169C2.83164 20.8525 3.3773 20.8525 4.46665 20.8525H9.92999C11.0184 20.8525 11.563 20.8525 11.9801 20.6169C12.3467 20.4098 12.6449 20.0792 12.8317 19.6726C13.0441 19.2101 13.0441 18.6061 13.0441 17.398V14.3693M7.19783 7.88605H9.92609C11.0174 7.88605 11.563 7.88605 11.9801 8.12161C12.3467 8.3288 12.6449 8.65939 12.8317 9.066C13.0441 9.52739 13.0441 10.1325 13.0441 11.3405V14.3693",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.2c76d576c684f056cb25673af74afc5c.svg";
export { ForwardRef as ReactComponent };